// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card[data-v-a7f9236e] {\n    width: 340px !important;\n    padding-bottom: 10px;\n}\n.forgot-password-form[data-v-a7f9236e] {\n    margin-top: 1em !important;\n    margin-bottom: 1em !important;\n}\n.email-sent-msg[data-v-a7f9236e] {\n    margin-bottom: 20px !important;\n}\n", ""]);
// Exports
module.exports = exports;
